export default __webpack_public_path__ + "static/Roboto-Italic-87f3afe16a8c3c3706340b027aa43a2e.ttf";